import * as React from "react";
const SvgSparkleRed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="#F05353"
      strokeWidth={2.25}
      d="m28.374 14.28-3.986-1.141a10.9 10.9 0 0 1-4.748-2.789 10.9 10.9 0 0 1-2.783-4.758l-1.139-3.995a.761.761 0 0 0-1.406 0l-1.14 3.995a10.9 10.9 0 0 1-2.782 4.758 10.9 10.9 0 0 1-4.748 2.789L1.656 14.28a.73.73 0 0 0-.383 1.147.73.73 0 0 0 .383.263l3.986 1.141a10.9 10.9 0 0 1 4.748 2.789 10.9 10.9 0 0 1 2.783 4.758l1.139 3.994a.732.732 0 0 0 1.144.385.73.73 0 0 0 .262-.385l1.14-3.994a10.9 10.9 0 0 1 2.782-4.758 10.9 10.9 0 0 1 4.748-2.789l3.986-1.141a.73.73 0 0 0 .383-1.147.73.73 0 0 0-.383-.263Z"
    />
  </svg>
);
export default SvgSparkleRed;
